module.exports = __webpack_public_path__ + "img/frhxq.eff43a2b.jpg";